import { render, staticRenderFns } from "./ListReponsavelAssociadoView.vue?vue&type=template&id=42d2a1f1&"
import script from "./ListReponsavelAssociadoView.vue?vue&type=script&lang=ts&"
export * from "./ListReponsavelAssociadoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports